













import { defineComponent } from '@nuxtjs/composition-api'
import Fa6SolidCaretDown from '~icons/fa6-solid/caret-down'
import Fa6SolidCaretUp from '~icons/fa6-solid/caret-up'
import { useI18n } from '~/composables/i18n'

export default defineComponent({
  components: { Fa6SolidCaretDown, Fa6SolidCaretUp },
  props: {
    headerText: {
      type: String,
      required: true,
    },
    showCaret: {
      type: Boolean,
      default: false,
    },
    caretDirection: {
      type: String as () => 'up' | 'down',
      required: false,
      default: 'down',
    },
  },
  emits: ['caret-click'],
  setup() {
    const { t } = useI18n()

    return {
      t,
    }
  },
})
